'use client'

import { useMemo } from 'react'
import { useLocale, useTranslations } from 'next-intl'
import { getPlanPresentation } from './presentation'

export function usePlanPresentation() {
  const t = useTranslations('PlanPresentation')
  const catalog = useTranslations('PlanCatalog')
  const locale = useLocale()
  return useMemo(() => getPlanPresentation(t, catalog, locale), [t, catalog, locale])
}
